@if (!loading()) {
  <div class="login-wrapper">
    <div class="login-intro">
      <div [ngStyle]="{ 'background-image': 'url(' + loginImage() + ')' }" class="banner"></div>
    </div>
    <div class="login-form-wrapper">
      <div class="login-form">
        <img [src]="logoImage()" class="logo" alt="Organisatie logo" />
        @switch (currentView()) {
          @case ('login') {
            <h1 class="title">Log in op de planomgeving van {{ organisationName() }}</h1>
            <form [formGroup]="loginForm" class="email-login">
              <mat-form-field [hideRequiredMarker]="true">
                <mat-label>E-mail</mat-label>
                <input #focusMeLogin matInput type="email" formControlName="email" (keyup.Enter)="login()" />
                @if (loginForm.controls.email.errors?.emailValidator) {
                  <mat-error>E-mailadres is ongeldig.</mat-error>
                }
                @if (loginForm.controls.email.errors?.required) {
                  <mat-error> Je moet je e-mail invullen.</mat-error>
                }
              </mat-form-field>
              <mat-form-field [hideRequiredMarker]="true">
                <mat-label>Wachtwoord</mat-label>
                @if (!showPasswords()) {
                  <input matInput type="password" formControlName="password" (keyup.Enter)="login()" />
                }
                @if (showPasswords()) {
                  <input matInput formControlName="password" (keyup.Enter)="login()" />
                }
                @if (!showPasswords()) {
                  <button
                    type="button"
                    matSuffix
                    mat-icon-button
                    aria-label="Wachtwoord laten zien"
                    matTooltip="Wachtwoord laten zien"
                    (click)="showPasswords.set(true)"
                  >
                    <mat-icon>visibility</mat-icon>
                  </button>
                }
                @if (showPasswords()) {
                  <button
                    type="button"
                    matSuffix
                    mat-icon-button
                    aria-label="Wachtwoord verbergen"
                    matTooltip="Wachtwoord verbergen"
                    (click)="showPasswords.set(false)"
                  >
                    <mat-icon>visibility_off</mat-icon>
                  </button>
                }
                @if (loginForm.controls.password.errors?.required) {
                  <mat-error> Je moet je wachtwoord invullen.</mat-error>
                }
              </mat-form-field>
              @if (errorLoginMessage()) {
                <mat-error role="alert">{{ errorLoginMessage() }}</mat-error>
              }
              <div class="forgot-password-wrapper">
                <a class="link" routerLink="/login/reset-password">Wachtwoord vergeten?</a>
              </div>
              <div class="login-button-wrapper">
                <button
                  mat-flat-button
                  [disabled]="!loginForm.valid"
                  color="primary"
                  class="login-button"
                  (click)="login()"
                >
                  Inloggen
                </button>
              </div>
            </form>
          }
          @case ('reset-password') {
            <h1 class="title">Wachtwoord vergeten?</h1>
            <div class="sub-title">
              Vul hier je e-mailadres in en wij sturen je instructies om je wachtwoord opnieuw in te stellen.
            </div>
            <form [formGroup]="passwordResetForm" class="email-login" (ngSubmit)="resetPassword()">
              @if (errorResetMessage()) {
                <mat-error role="alert">{{ errorResetMessage() }}</mat-error>
              }
              <mat-form-field [hideRequiredMarker]="true">
                <mat-label>E-mail</mat-label>
                <input matInput type="email" formControlName="email" />
                @if (
                  passwordResetForm.controls.email.errors?.emailValidator &&
                  !passwordResetForm.controls.email.errors?.required
                ) {
                  <mat-error>E-mailadres is ongeldig.</mat-error>
                }
                @if (passwordResetForm.controls.email.errors?.required) {
                  <mat-error>Je moet je e-mail invullen.</mat-error>
                }
              </mat-form-field>
              <div class="forgot-pass-actions">
                <button type="button" mat-stroked-button color="primary" class="login-button" routerLink="/login">
                  <mat-icon>arrow_back</mat-icon> Terug
                </button>
                <button mat-flat-button type="submit" [disabled]="sendingReset()" color="primary" class="login-button">
                  Reset wachtwoord
                </button>
              </div>
            </form>
          }
        }
      </div>
    </div>
  </div>
}
